{
  "analysis_structured": {
    "c1_ethics_concern": false,
    "c1_observed_only": true,
    "c2_note": "Bu yeterlilik alanında davranışsal ifade bulunmamaktadır. Koçluk zihin yapısını sürdürmek — açık, meraklı, esnek ve müşteri merkezli kalmak — koçun mesleki yolculuğu boyunca gelişir ve tek bir kayıtlı görüşme üzerinden değerlendirilemez. Bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.",
    "c2_transcript_assessed": false,
    "competency_analyses": {
      "C1": {
        "additional_evidence": [],
        "competency_code": "C1",
        "development_examples": [],
        "level": "",
        "narrative": "Gözlemlendi. Bu görüşmede etik uygulamalara ve koçluk duruşuna uygun davranışlar gözlemlenmiş, etik ilkelere aykırı bir davranış gözlemlenmemiştir. Etik uygulama bir beceri düzeyi değil, karşılanması gereken bir ön koşuldur; bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?",
            "rationale": "Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.",
            "timestamp": "02:12"
          }
        ]
      },
      "C2": {
        "additional_evidence": [],
        "competency_code": "C2",
        "development_examples": [],
        "level": "",
        "narrative": "Bu yeterlilik alanında davranışsal ifade bulunmamaktadır. Koçluk zihin yapısını sürdürmek — açık, meraklı, esnek ve müşteri merkezli kalmak — koçun mesleki yolculuğu boyunca gelişir ve tek bir kayıtlı görüşme üzerinden değerlendirilemez. Bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.",
        "positive_examples": []
      },
      "C3": {
        "additional_evidence": [],
        "competency_code": "C3",
        "development_examples": [],
        "level": "pcc",
        "narrative": "Görüşme anlaşması somuttur ve danışanın istediği sonuçla bağlantısını korur.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Görüşmenin sonunda netliğe ulaşırsak senin için ne farklı olacak?",
            "rationale": "Oturum sonucunu gözlemlenebilir biçimde netleştirir.",
            "timestamp": "03:04"
          }
        ]
      },
      "C4": {
        "additional_evidence": [],
        "competency_code": "C4",
        "development_examples": [],
        "level": "pcc",
        "narrative": "Danışana yargılanmadan sesli düşünme alanı verilir.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Acele etme. Burada doğru bir yanıt yok.",
            "rationale": "Psikolojik güvenliği ve düşünmeyi destekler.",
            "timestamp": "09:36"
          }
        ]
      },
      "C5": {
        "additional_evidence": [],
        "competency_code": "C5",
        "development_examples": [
          {
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "timestamp": "19:18"
          }
        ],
        "level": "pcc",
        "narrative": "Koçun varlığı dengeli ve duyarlıdır; sonraki gelişim alanı güçlü sorulardan sonra sessizliği kullanmaktır.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Bununla otururken içinde neler oluyor?",
            "rationale": "Dikkati danışanın o andaki deneyimine getirir.",
            "timestamp": "21:10"
          }
        ]
      },
      "C6": {
        "additional_evidence": [],
        "competency_code": "C6",
        "development_examples": [
          {
            "marker_ids": [],
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
            "timestamp": "24:33"
          }
        ],
        "level": "mcc",
        "narrative": "Koç yalnızca içeriği değil; kimliği, enerjiyi ve anlam değişimlerini de dinler.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
            "rationale": "Danışanın dilini kullanarak anlamı araştırır.",
            "timestamp": "12:41"
          }
        ]
      },
      "C7": {
        "additional_evidence": [],
        "competency_code": "C7",
        "development_examples": [
          {
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "Örtük bir çözüm içerir.",
            "timestamp": "19:18"
          }
        ],
        "level": "pcc",
        "narrative": "Farkındalık, danışanın kimliği ve seçimleriyle bağlantılı kısa sorularla ortaya çıkarılır.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Güvenilir olmak yardım istemeyi de içerirse neler mümkün olur?",
            "rationale": "Danışanın kendi temasına dayalı yeni bir çerçeve açar.",
            "timestamp": "14:08"
          },
          {
            "marker_ids": [],
            "quote": "Bu sınırın senin kendi sesindeki hâli nasıl duyulurdu?",
            "rationale": "Farkındalığı özgün bir ifadeye taşır.",
            "timestamp": "28:06"
          }
        ]
      },
      "C8": {
        "additional_evidence": [],
        "competency_code": "C8",
        "development_examples": [],
        "level": "pcc",
        "narrative": "Danışan ölçülebilir bir deneyi kendisi tasarlar ve uygulamak için gereken desteği adlandırır.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Bu hafta denemeye hazır olduğun küçük adım ne?",
            "rationale": "İçgörüyü danışanın sahiplendiği bir eyleme dönüştürür.",
            "timestamp": "31:52"
          },
          {
            "marker_ids": [],
            "quote": "Cuma günü bu deneyin işe yaradığını sana ne gösterecek?",
            "rationale": "Başarı kanıtını danışanın tanımlamasını sağlar.",
            "timestamp": "34:27"
          }
        ]
      }
    },
    "competency_decision_table": [
      {
        "competency_code": "C1",
        "competency_name": "Etik Uygulama Sergiler",
        "confidence": null,
        "inconsistent_patterns": [],
        "level": "",
        "level_label": "Gözlemlendi",
        "summary": "Gözlemlendi. Bu görüşmede etik uygulamalara ve koçluk duruşuna uygun davranışlar gözlemlenmiş, etik ilkelere aykırı bir davranış gözlemlenmemiştir. Etik uygulama bir beceri düzeyi değil, karşılanması gereken bir ön koşuldur; bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez."
      },
      {
        "competency_code": "C2",
        "competency_name": "Koçluk Zihin Yapısını Sürdürür",
        "confidence": null,
        "inconsistent_patterns": [],
        "level": "",
        "level_label": "—",
        "summary": "Bu yeterlilik alanında davranışsal ifade bulunmamaktadır. Koçluk zihin yapısını sürdürmek — açık, meraklı, esnek ve müşteri merkezli kalmak — koçun mesleki yolculuğu boyunca gelişir ve tek bir kayıtlı görüşme üzerinden değerlendirilemez. Bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez."
      },
      {
        "competency_code": "C3",
        "competency_name": "Anlaşmalar Yapar ve Sürdürür",
        "confidence": 0.93,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC Düzeyi",
        "summary": "Görüşme anlaşması somuttur ve danışanın istediği sonuçla bağlantısını korur."
      },
      {
        "competency_code": "C4",
        "competency_name": "Güven ve Güvenlik Oluşturur",
        "confidence": 0.94,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC Düzeyi",
        "summary": "Danışana yargılanmadan sesli düşünme alanı verilir."
      },
      {
        "competency_code": "C5",
        "competency_name": "Varlığını Sürdürür",
        "confidence": 0.86,
        "inconsistent_patterns": [
          "Zaman zaman üst üste sorulan sorular düşünme alanını daraltıyor."
        ],
        "level": "pcc",
        "level_label": "PCC Düzeyi",
        "summary": "Koçun varlığı dengeli ve duyarlıdır; sonraki gelişim alanı güçlü sorulardan sonra sessizliği kullanmaktır."
      },
      {
        "competency_code": "C6",
        "competency_name": "Aktif Dinler",
        "confidence": 0.95,
        "inconsistent_patterns": [],
        "level": "mcc",
        "level_label": "MCC Düzeyi",
        "summary": "Koç yalnızca içeriği değil; kimliği, enerjiyi ve anlam değişimlerini de dinler."
      },
      {
        "competency_code": "C7",
        "competency_name": "Farkındalık Uyandırır",
        "confidence": 0.91,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC Düzeyi",
        "summary": "Farkındalık, danışanın kimliği ve seçimleriyle bağlantılı kısa sorularla ortaya çıkarılır."
      },
      {
        "competency_code": "C8",
        "competency_name": "Müşteri Gelişimini Kolaylaştırır",
        "confidence": 0.92,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC Düzeyi",
        "summary": "Danışan ölçülebilir bir deneyi kendisi tasarlar ve uygulamak için gereken desteği adlandırır."
      }
    ],
    "competency_levels": {
      "C3": "pcc",
      "C4": "pcc",
      "C5": "pcc",
      "C6": "mcc",
      "C7": "pcc",
      "C8": "pcc"
    },
    "competency_verdicts": {
      "C3": {
        "confidence": 0.93,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "Görüşmenin sonunda netliğe ulaşırsak senin için ne farklı olacak?",
            "timestamp": "03:04"
          }
        ],
        "summary": "Görüşme anlaşması somuttur ve danışanın istediği sonuçla bağlantısını korur."
      },
      "C4": {
        "confidence": 0.94,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "Acele etme. Burada doğru bir yanıt yok.",
            "timestamp": "09:36"
          }
        ],
        "summary": "Danışana yargılanmadan sesli düşünme alanı verilir."
      },
      "C5": {
        "confidence": 0.86,
        "development_evidence": [
          {
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "timestamp": "19:18"
          }
        ],
        "inconsistent_patterns": [
          "Zaman zaman üst üste sorulan sorular düşünme alanını daraltıyor."
        ],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "Bununla otururken içinde neler oluyor?",
            "timestamp": "21:10"
          }
        ],
        "summary": "Koçun varlığı dengeli ve duyarlıdır; sonraki gelişim alanı güçlü sorulardan sonra sessizliği kullanmaktır."
      },
      "C6": {
        "confidence": 0.95,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "mcc",
        "positive_evidence": [
          {
            "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
            "timestamp": "12:41"
          },
          {
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "timestamp": "24:33"
          }
        ],
        "summary": "Koç yalnızca içeriği değil; kimliği, enerjiyi ve anlam değişimlerini de dinler."
      },
      "C7": {
        "confidence": 0.91,
        "development_evidence": [
          {
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "timestamp": "19:18"
          }
        ],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "Güvenilir olmak yardım istemeyi de içerirse neler mümkün olur?",
            "timestamp": "14:08"
          },
          {
            "quote": "Bu sınırın senin kendi sesindeki hâli nasıl duyulurdu?",
            "timestamp": "28:06"
          }
        ],
        "summary": "Farkındalık, danışanın kimliği ve seçimleriyle bağlantılı kısa sorularla ortaya çıkarılır."
      },
      "C8": {
        "confidence": 0.92,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "Bu hafta denemeye hazır olduğun küçük adım ne?",
            "timestamp": "31:52"
          },
          {
            "quote": "Cuma günü bu deneyin işe yaradığını sana ne gösterecek?",
            "timestamp": "34:27"
          }
        ],
        "summary": "Danışan ölçülebilir bir deneyi kendisi tasarlar ve uygulamak için gereken desteği adlandırır."
      }
    },
    "development_areas": [
      {
        "marker_ids": [],
        "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
        "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
        "timestamp": "19:18"
      },
      {
        "marker_ids": [],
        "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
        "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
        "timestamp": "24:33"
      }
    ],
    "level_decision": {
      "caveat": "Bu sonuç resmî bir ICF geçme/kalma kararı değildir; eğitim ve mentor koçluk amacıyla hazırlanmış, kanıta dayalı bir gelişimsel seviye tahminidir.",
      "competency_level_counts": {
        "mcc": 1,
        "pcc": 5
      },
      "confidence_band": "medium",
      "confidence_label": "Orta",
      "decision_competencies": [
        "C3",
        "C4",
        "C5",
        "C6",
        "C7",
        "C8"
      ],
      "limiting_competencies": [
        "C3",
        "C4",
        "C5",
        "C7",
        "C8"
      ],
      "non_decision_competencies": [
        "C1",
        "C2"
      ],
      "overall_level": "pcc",
      "overall_level_label": "PCC Düzeyi",
      "rationale": "Genel karar PCC Düzeyi olarak tutuldu; yetkinlik dağılımı (PCC Düzeyi: 5, MCC Düzeyi: 1) ve yapılandırılmış kanıt taraması bu seviyeyi en dengeli gelişimsel seviye tahmini olarak destekliyor. Bu karar C3-C8 davranışlarına dayanır; C1 ve C2 raporlanır, ancak seviye kararını doğrudan belirleyen yetkinlikler değildir. Kararı destekleyen güçlü alanlar: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C6 Aktif Dinler.",
      "supporting_competencies": [
        "C3",
        "C4",
        "C5",
        "C6",
        "C7",
        "C8"
      ],
      "why_not_higher": "MCC Düzeyi değil; çünkü bir üst seviyeye ait davranışlar görüşme boyunca yeterince tutarlı görünmüyor. Sınırlayıcı alanlar: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C7 Farkındalık Uyandırır. Öne çıkan sınırlayıcı örüntü: Zaman zaman üst üste sorulan sorular düşünme alanını daraltıyor.",
      "why_not_lower": "PCC Hazırlık Bandı veya altı değil; çünkü görüşmede bu seviyenin üzerinde tutarlı koçluk kanıtları var: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C6 Aktif Dinler."
    },
    "mentor_detailed_report": {
      "calibration_notes": [],
      "development_opportunities": [
        {
          "competency_code": "",
          "competency_name": "",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
              "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
              "source": "development",
              "timestamp": "19:18"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "İki soruyu üst üste getirir ve bir yön ima eder."
        },
        {
          "competency_code": "",
          "competency_name": "",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
              "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
              "source": "development",
              "timestamp": "24:33"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Ton değişimini danışan adına yorumlamadan görünür kılar."
        },
        {
          "competency_code": "C5",
          "competency_name": "Varlığını Sürdürür",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
              "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
              "source": "development",
              "timestamp": "19:18"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "İki soruyu üst üste getirir ve bir yön ima eder."
        },
        {
          "competency_code": "C6",
          "competency_name": "Aktif Dinler",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
              "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
              "source": "development",
              "timestamp": "24:33"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Ton değişimini danışan adına yorumlamadan görünür kılar."
        },
        {
          "competency_code": "C7",
          "competency_name": "Farkındalık Uyandırır",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
              "rationale": "Örtük bir çözüm içerir.",
              "source": "development",
              "timestamp": "19:18"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Örtük bir çözüm içerir."
        }
      ],
      "evidence_map": [
        {
          "competency_code": "",
          "marker_ids": [],
          "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
          "rationale": "Danışanın dilini kullanarak anlamı araştırır.",
          "source": "strengths",
          "timestamp": "12:41"
        },
        {
          "competency_code": "",
          "marker_ids": [],
          "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
          "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
          "source": "development_areas",
          "timestamp": "19:18"
        },
        {
          "competency_code": "",
          "marker_ids": [],
          "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
          "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
          "source": "development_areas",
          "timestamp": "24:33"
        },
        {
          "competency_code": "C1",
          "marker_ids": [],
          "quote": "Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?",
          "rationale": "Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.",
          "source": "C1.positive_examples",
          "timestamp": "02:12"
        },
        {
          "competency_code": "C3",
          "marker_ids": [],
          "quote": "Görüşmenin sonunda netliğe ulaşırsak senin için ne farklı olacak?",
          "rationale": "Oturum sonucunu gözlemlenebilir biçimde netleştirir.",
          "source": "C3.positive_examples",
          "timestamp": "03:04"
        },
        {
          "competency_code": "C4",
          "marker_ids": [],
          "quote": "Acele etme. Burada doğru bir yanıt yok.",
          "rationale": "Psikolojik güvenliği ve düşünmeyi destekler.",
          "source": "C4.positive_examples",
          "timestamp": "09:36"
        }
      ],
      "language": "tr",
      "level_reasoning": {
        "c1_c2_boundary": "C1, etik ve rol sınırlarına ilişkin bir eşik olarak ele alınır; C2 ise görüşme dökümündeki davranışlardan türetilir ve seviye kararını olduğundan yüksek göstermek için kullanılmaz.",
        "decision_basis": "Genel karar PCC Düzeyi olarak tutuldu; yetkinlik dağılımı (PCC Düzeyi: 5, MCC Düzeyi: 1) ve yapılandırılmış kanıt taraması bu seviyeyi en dengeli gelişimsel seviye tahmini olarak destekliyor. Bu karar C3-C8 davranışlarına dayanır; C1 ve C2 raporlanır, ancak seviye kararını doğrudan belirleyen yetkinlikler değildir. Kararı destekleyen güçlü alanlar: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C6 Aktif Dinler.",
        "why_not_higher": "MCC Düzeyi değil; çünkü bir üst seviyeye ait davranışlar görüşme boyunca yeterince tutarlı görünmüyor. Sınırlayıcı alanlar: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C7 Farkındalık Uyandırır. Öne çıkan sınırlayıcı örüntü: Zaman zaman üst üste sorulan sorular düşünme alanını daraltıyor.",
        "why_not_lower": "PCC Hazırlık Bandı veya altı değil; çünkü görüşmede bu seviyenin üzerinde tutarlı koçluk kanıtları var: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C6 Aktif Dinler."
      },
      "level_summary": {
        "competing_level": null,
        "confidence_band": "medium",
        "estimated_level": "pcc",
        "level_label": "PCC Düzeyi",
        "level_semantics": "closest_demonstrated_level",
        "review_recommended": false
      },
      "limitations": [
        "Bu rapor resmî bir ICF unvan kararı değildir; mentor koçluk görüşmesine hazırlık amacıyla kanıta dayalı gelişim geri bildirimi sunar."
      ],
      "live_mentor_session_questions": [
        {
          "question": "19:18 zamanındaki “Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?” anı incelendiğinde, koç müşterinin içgörüsünü derinleştirdi mi yoksa odağı fazla hızlı mı eyleme taşıdı?",
          "related_competency": "",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "source": "development",
            "timestamp": "19:18"
          },
          "why_discuss_with_mentor": "Bu soru, mentor koçluk görüşmesinde davranış kanıtını birlikte incelemeye ve daha net bir uygulama odağı seçmeye yardımcı olur."
        },
        {
          "question": "24:33 zamanındaki ““İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?” anı için mentor koç, müşterinin daha fazla yön verdiği hangi kısa müdahaleyi denerdi?",
          "related_competency": "",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
            "source": "development",
            "timestamp": "24:33"
          },
          "why_discuss_with_mentor": "Bu soru, mentor koçluk görüşmesinde davranış kanıtını birlikte incelemeye ve daha net bir uygulama odağı seçmeye yardımcı olur."
        },
        {
          "question": "12:41 zamanındaki ““Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?” anı güçlü kanıtı hangi koşullarda oturumun geneline daha tutarlı yayılabilir?",
          "related_competency": "",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
            "rationale": "Danışanın dilini kullanarak anlamı araştırır.",
            "source": "strength",
            "timestamp": "12:41"
          },
          "why_discuss_with_mentor": "Bu soru, mentor koçluk görüşmesinde davranış kanıtını birlikte incelemeye ve daha net bir uygulama odağı seçmeye yardımcı olur."
        },
        {
          "question": "02:12 zamanındaki “Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?” anı müşterinin anlam dünyasıyla çalışma, ilişki kalitesi veya koçluk varlığı açısından ne gösteriyor?",
          "related_competency": "C1",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?",
            "rationale": "Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.",
            "source": "strength",
            "timestamp": "02:12"
          },
          "why_discuss_with_mentor": "Bu soru, mentor koçluk görüşmesinde davranış kanıtını birlikte incelemeye ve daha net bir uygulama odağı seçmeye yardımcı olur."
        }
      ],
      "next_level_shift": [
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "source": "development",
            "timestamp": "19:18"
          },
          "related_competency": "",
          "summary": "MCC Düzeyi düzeyine yaklaşmak için bu yetkinlik alanındaki müdahalelerin müşterinin daha fazla yön verdiği, kanıta duyarlı ve içgörüyü derinleştiren bir biçimde sürdürülmesi gerekir.",
          "target_level": "mcc"
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
            "source": "development",
            "timestamp": "24:33"
          },
          "related_competency": "",
          "summary": "MCC Düzeyi düzeyine yaklaşmak için bu yetkinlik alanındaki müdahalelerin müşterinin daha fazla yön verdiği, kanıta duyarlı ve içgörüyü derinleştiren bir biçimde sürdürülmesi gerekir.",
          "target_level": "mcc"
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "source": "development",
            "timestamp": "19:18"
          },
          "related_competency": "C5",
          "summary": "MCC Düzeyi düzeyine yaklaşmak için C5 alanındaki müdahalelerin müşterinin daha fazla yön verdiği, kanıta duyarlı ve içgörüyü derinleştiren bir biçimde sürdürülmesi gerekir.",
          "target_level": "mcc"
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
            "source": "development",
            "timestamp": "24:33"
          },
          "related_competency": "C6",
          "summary": "MCC Düzeyi düzeyine yaklaşmak için C6 alanındaki müdahalelerin müşterinin daha fazla yön verdiği, kanıta duyarlı ve içgörüyü derinleştiren bir biçimde sürdürülmesi gerekir.",
          "target_level": "mcc"
        }
      ],
      "next_session_practice_plan": [
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "source": "development",
            "timestamp": "19:18"
          },
          "practice_focus": "Seçilen yetkinlik için bir sonraki görüşmede daha kısa, açık ve müşterinin yön verdiği bir müdahale deneyin.",
          "related_competency": "",
          "success_indicator": "Müşteri kendi farkındalığını, seçimini veya sonraki adımını daha çok kendi kelimeleriyle ifade eder."
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
            "source": "development",
            "timestamp": "24:33"
          },
          "practice_focus": "Seçilen yetkinlik için bir sonraki görüşmede daha kısa, açık ve müşterinin yön verdiği bir müdahale deneyin.",
          "related_competency": "",
          "success_indicator": "Müşteri kendi farkındalığını, seçimini veya sonraki adımını daha çok kendi kelimeleriyle ifade eder."
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "source": "development",
            "timestamp": "19:18"
          },
          "practice_focus": "C5 için bir sonraki görüşmede daha kısa, açık ve müşterinin yön verdiği bir müdahale deneyin.",
          "related_competency": "C5",
          "success_indicator": "Müşteri kendi farkındalığını, seçimini veya sonraki adımını daha çok kendi kelimeleriyle ifade eder."
        }
      ],
      "public_boundary": "Bu rapor resmî bir ICF unvan kararı değildir; mentor koçluk görüşmesine hazırlık amacıyla kanıta dayalı gelişim geri bildirimi sunar.",
      "session_snapshot": "**PCC düzeyinde performans.** Koç danışanla tutarlı biçimde ortaklık kuruyor, sözcüklerin altındaki anlamı dinliyor ve oluşan farkındalığı danışanın sahiplendiği bir deneye dönüştürüyor. En net gelişim alanı, ikinci bir soru eklemeden önce daha fazla sessizliğe izin vermek.",
      "strengths": [
        {
          "competency_code": "",
          "competency_name": "",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
              "rationale": "Danışanın dilini kullanarak anlamı araştırır.",
              "source": "strength",
              "timestamp": "12:41"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Danışanın dilini kullanarak anlamı araştırır."
        },
        {
          "competency_code": "C1",
          "competency_name": "Etik Uygulama Sergiler",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?",
              "rationale": "Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.",
              "source": "strength",
              "timestamp": "02:12"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder."
        },
        {
          "competency_code": "C3",
          "competency_name": "Anlaşmalar Yapar ve Sürdürür",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Görüşmenin sonunda netliğe ulaşırsak senin için ne farklı olacak?",
              "rationale": "Oturum sonucunu gözlemlenebilir biçimde netleştirir.",
              "source": "strength",
              "timestamp": "03:04"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Oturum sonucunu gözlemlenebilir biçimde netleştirir."
        },
        {
          "competency_code": "C4",
          "competency_name": "Güven ve Güvenlik Oluşturur",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Acele etme. Burada doğru bir yanıt yok.",
              "rationale": "Psikolojik güvenliği ve düşünmeyi destekler.",
              "source": "strength",
              "timestamp": "09:36"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Psikolojik güvenliği ve düşünmeyi destekler."
        },
        {
          "competency_code": "C5",
          "competency_name": "Varlığını Sürdürür",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Bununla otururken içinde neler oluyor?",
              "rationale": "Dikkati danışanın o andaki deneyimine getirir.",
              "source": "strength",
              "timestamp": "21:10"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Dikkati danışanın o andaki deneyimine getirir."
        }
      ],
      "template_id": "mentor_detailed_v1",
      "upper_level_nuance_profile": {
        "bias_boundary": "Bu değerlendirme; konuşma hızı, dil akıcılığı, enerji düzeyi veya kişisel stil yerine gözlemlenebilir koçluk davranışlarına dayandırılmıştır.",
        "client_meaning_world": "not_observed",
        "coaching_presence": "not_observed",
        "depth_of_exploration": "not_observed",
        "evidence": [
          {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
            "rationale": "Danışanın dilini kullanarak anlamı araştırır.",
            "source": "strengths",
            "timestamp": "12:41"
          },
          {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?",
            "rationale": "İki soruyu üst üste getirir ve bir yön ima eder.",
            "source": "development_areas",
            "timestamp": "19:18"
          },
          {
            "competency_code": "",
            "marker_ids": [],
            "quote": "“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?",
            "rationale": "Ton değişimini danışan adına yorumlamadan görünür kılar.",
            "source": "development_areas",
            "timestamp": "24:33"
          },
          {
            "competency_code": "C1",
            "marker_ids": [],
            "quote": "Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?",
            "rationale": "Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.",
            "source": "C1.positive_examples",
            "timestamp": "02:12"
          }
        ],
        "facilitates_growth_impact": "not_observed",
        "limitations": [
          "Bu profil üst düzey nitelikleri görünür kılar; ancak mevcut kanıtlar tek başına MCC düzeyine yakın bir sonuç çıkarmak için yeterli değildir."
        ],
        "mcc_adjacent_signal": false,
        "public_boundary": "Bu bölüm resmî bir MCC puanlama formülü değildir. Görüşmede gözlemlenen üst düzey koçluk niteliklerini gelişim amacıyla görünür kılar.",
        "relationship_quality": "not_observed",
        "subtlety_and_artistry": "not_observed"
      }
    },
    "overall_assessment": "**PCC düzeyinde performans.** Koç danışanla tutarlı biçimde ortaklık kuruyor, sözcüklerin altındaki anlamı dinliyor ve oluşan farkındalığı danışanın sahiplendiği bir deneye dönüştürüyor. En net gelişim alanı, ikinci bir soru eklemeden önce daha fazla sessizliğe izin vermek.",
    "overall_level": "pcc",
    "phase2_contract": "competency_v1",
    "recommendations": [
      "Duygusal açıdan önemli danışan ifadelerinden sonra tek bir soru sor.",
      "Danışan düşünürken yeni bir cümle eklemeden önce iki tam nefes bekle.",
      "Eylem tasarımını danışanın adlandırdığı kimlik değişimine bağlamayı sürdür."
    ],
    "requested_level": null,
    "review_recommended": false,
    "strengths": [
      {
        "marker_ids": [],
        "quote": "“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?",
        "rationale": "Danışanın dilini kullanarak anlamı araştırır.",
        "timestamp": "12:41"
      }
    ],
    "what_who_balance": "balanced"
  },
  "analysis_text": "### BÖLÜM 0: SEVİYE KARARI\n**GENEL SEVİYE:** PCC Düzeyi\n**GÜVEN:** Orta\n**Kararın gerekçesi:** Genel karar PCC Düzeyi olarak tutuldu; yetkinlik dağılımı (PCC Düzeyi: 5, MCC Düzeyi: 1) ve yapılandırılmış kanıt taraması bu seviyeyi en dengeli gelişimsel seviye tahmini olarak destekliyor. Bu karar C3-C8 davranışlarına dayanır; C1 ve C2 raporlanır, ancak seviye kararını doğrudan belirleyen yetkinlikler değildir. Kararı destekleyen güçlü alanlar: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C6 Aktif Dinler.\n**Neden bir üst seviye değil:** MCC Düzeyi değil; çünkü bir üst seviyeye ait davranışlar görüşme boyunca yeterince tutarlı görünmüyor. Sınırlayıcı alanlar: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C7 Farkındalık Uyandırır. Öne çıkan sınırlayıcı örüntü: Zaman zaman üst üste sorulan sorular düşünme alanını daraltıyor.\n**Neden bir alt seviye değil:** PCC Hazırlık Bandı veya altı değil; çünkü görüşmede bu seviyenin üzerinde tutarlı koçluk kanıtları var: C3 Anlaşmalar Yapar ve Sürdürür, C4 Güven ve Güvenlik Oluşturur, C5 Varlığını Sürdürür, C6 Aktif Dinler.\n**Not:** Bu sonuç resmî bir ICF geçme/kalma kararı değildir; eğitim ve mentor koçluk amacıyla hazırlanmış, kanıta dayalı bir gelişimsel seviye tahminidir.\n\n### BÖLÜM 1: GENEL DEĞERLENDİRME\n\nMETRİKLER:\n- What/Who Dengesi: Dengeli\n\n**PCC düzeyinde performans.** Koç danışanla tutarlı biçimde ortaklık kuruyor, sözcüklerin altındaki anlamı dinliyor ve oluşan farkındalığı danışanın sahiplendiği bir deneye dönüştürüyor. En net gelişim alanı, ikinci bir soru eklemeden önce daha fazla sessizliğe izin vermek.\n\nSONUÇ: Gözlemlenen davranışlar genel olarak PCC Düzeyi ile uyumludur.\n\n### BÖLÜM 2: GÜÇLÜ YÖNLER\n- (12:41) \"“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?\" - Danışanın dilini kullanarak anlamı araştırır.\n\n### BÖLÜM 3: GELİŞİM ALANLARI\n- (19:18) \"Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?\" - İki soruyu üst üste getirir ve bir yön ima eder.\n- (24:33) \"“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?\" - Ton değişimini danışan adına yorumlamadan görünür kılar.\n\n### BÖLÜM 4: AYRINTILI YETKİNLİK ANALİZİ\n\n| Yetkinlik | Seviye | Kanıt Özeti |\n|-----------|--------|-------------|\n| 1. Etik Uygulama Sergiler | Gözlemlendi | Gözlemlendi. |\n| 2. Koçluk Zihin Yapısını Sürdürür | — | Bu yeterlilik alanında davranışsal ifade bulunmamaktadır. |\n| 3. Anlaşmalar Yapar ve Sürdürür | PCC Düzeyi | Görüşme anlaşması somuttur ve danışanın istediği sonuçla bağlantısını korur. |\n| 4. Güven ve Güvenlik Oluşturur | PCC Düzeyi | Danışana yargılanmadan sesli düşünme alanı verilir. |\n| 5. Varlığını Sürdürür | PCC Düzeyi | Koçun varlığı dengeli ve duyarlıdır; sonraki gelişim alanı güçlü sorulardan sonra sessizliği kullanmaktır. |\n| 6. Aktif Dinler | MCC Düzeyi | Koç yalnızca içeriği değil; kimliği, enerjiyi ve anlam değişimlerini de dinler. |\n| 7. Farkındalık Uyandırır | PCC Düzeyi | Farkındalık, danışanın kimliği ve seçimleriyle bağlantılı kısa sorularla ortaya çıkarılır. |\n| 8. Müşteri Gelişimini Kolaylaştırır | PCC Düzeyi | Danışan ölçülebilir bir deneyi kendisi tasarlar ve uygulamak için gereken desteği adlandırır. |\n\n**1. Etik Uygulama Sergiler**\nGözlemlendi. Bu görüşmede etik uygulamalara ve koçluk duruşuna uygun davranışlar gözlemlenmiş, etik ilkelere aykırı bir davranış gözlemlenmemiştir. Etik uygulama bir beceri düzeyi değil, karşılanması gereken bir ön koşuldur; bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.\nGüçlü Örnek: (02:12) \"Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?\" - Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.\n\n**2. Koçluk Zihin Yapısını Sürdürür**\nBu yeterlilik alanında davranışsal ifade bulunmamaktadır. Koçluk zihin yapısını sürdürmek — açık, meraklı, esnek ve müşteri merkezli kalmak — koçun mesleki yolculuğu boyunca gelişir ve tek bir kayıtlı görüşme üzerinden değerlendirilemez. Bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.\n\n**3. Anlaşmalar Yapar ve Sürdürür**\nSeviye: PCC Düzeyi\nGörüşme anlaşması somuttur ve danışanın istediği sonuçla bağlantısını korur.\nGüçlü Örnek: (03:04) \"Görüşmenin sonunda netliğe ulaşırsak senin için ne farklı olacak?\" - Oturum sonucunu gözlemlenebilir biçimde netleştirir.\n\n**4. Güven ve Güvenlik Oluşturur**\nSeviye: PCC Düzeyi\nDanışana yargılanmadan sesli düşünme alanı verilir.\nGüçlü Örnek: (09:36) \"Acele etme. Burada doğru bir yanıt yok.\" - Psikolojik güvenliği ve düşünmeyi destekler.\n\n**5. Varlığını Sürdürür**\nSeviye: PCC Düzeyi\nKoçun varlığı dengeli ve duyarlıdır; sonraki gelişim alanı güçlü sorulardan sonra sessizliği kullanmaktır.\nGüçlü Örnek: (21:10) \"Bununla otururken içinde neler oluyor?\" - Dikkati danışanın o andaki deneyimine getirir.\nGelişim Örneği: (19:18) \"Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?\" - İki soruyu üst üste getirir ve bir yön ima eder.\n\n**6. Aktif Dinler**\nSeviye: MCC Düzeyi\nKoç yalnızca içeriği değil; kimliği, enerjiyi ve anlam değişimlerini de dinler.\nGüçlü Örnek: (12:41) \"“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?\" - Danışanın dilini kullanarak anlamı araştırır.\nGelişim Örneği: (24:33) \"“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?\" - Ton değişimini danışan adına yorumlamadan görünür kılar.\n\n**7. Farkındalık Uyandırır**\nSeviye: PCC Düzeyi\nFarkındalık, danışanın kimliği ve seçimleriyle bağlantılı kısa sorularla ortaya çıkarılır.\nGüçlü Örnek: (14:08) \"Güvenilir olmak yardım istemeyi de içerirse neler mümkün olur?\" - Danışanın kendi temasına dayalı yeni bir çerçeve açar.\nGüçlü Örnek: (28:06) \"Bu sınırın senin kendi sesindeki hâli nasıl duyulurdu?\" - Farkındalığı özgün bir ifadeye taşır.\nGelişim Örneği: (19:18) \"Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?\" - Örtük bir çözüm içerir.\n\n**8. Müşteri Gelişimini Kolaylaştırır**\nSeviye: PCC Düzeyi\nDanışan ölçülebilir bir deneyi kendisi tasarlar ve uygulamak için gereken desteği adlandırır.\nGüçlü Örnek: (31:52) \"Bu hafta denemeye hazır olduğun küçük adım ne?\" - İçgörüyü danışanın sahiplendiği bir eyleme dönüştürür.\nGüçlü Örnek: (34:27) \"Cuma günü bu deneyin işe yaradığını sana ne gösterecek?\" - Başarı kanıtını danışanın tanımlamasını sağlar.\n\n### BÖLÜM 5: ÖNERİLER\n- Duygusal açıdan önemli danışan ifadelerinden sonra tek bir soru sor.\n- Danışan düşünürken yeni bir cümle eklemeden önce iki tam nefes bekle.\n- Eylem tasarımını danışanın adlandırdığı kimlik değişimine bağlamayı sürdür.\n\n**GENEL SEVİYE ÖZETİ:** PCC Düzeyi",
  "meta": {
    "client_name": "Maya Reed (kurgusal)",
    "coach_name": "Elena Hart (kurgusal)",
    "duration_minutes": 38,
    "is_fictional": true,
    "language": "tr",
    "sample_version": 3,
    "source": "Grading-engine inputs taken from the previous hand-authored sample (frontend/src/data/sampleReport.ts + sampleReport.* copy). TODO: regenerate from a real run of the agentic grading engine on a fictional transcript.",
    "title": "PCC demo oturumu — sürdürülebilir bir liderlik ritmi bulmak"
  }
}
